<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M10.5677,0.420965C10.5582,0.460964,10.5496,0.501331,10.542,0.542042C9.70455,0.697734,9.01235,1.27236,8.6919,2.03946C8.46488,2.0134,8.234,2,8,2C4.68629,2,2,4.68629,2,8C2,11.3137,4.68629,14,8,14C11.3137,14,14,11.3137,14,8C14,7.76757,13.9868,7.53823,13.9611,7.31269C14.7286,6.99167,15.303,6.298,15.4582,5.45791C15.4988,5.45035,15.5391,5.44181,15.579,5.43231C15.852,6.23826,16,7.10185,16,8C16,12.4183,12.4183,16,8,16C3.58172,16,0,12.4183,0,8C0,3.58172,3.58172,0,8,0C8.89815,0,9.76174,0.148008,10.5677,0.420965C10.5677,0.420965,10.5677,0.420965,10.5677,0.420965ZM9,12C9,12,7,12,7,12C7,12,7,10,7,10C7,10,9,10,9,10C9,10,9,12,9,12C9,12,9,12,9,12ZM9,9C9,9,7,9,7,9C7,9,7,4,7,4C7,4,9,4,9,4C9,4,9,9,9,9C9,9,9,9,9,9ZM10,3C10,2.45,10.45,2,11,2C11,2,12,2,12,2C12,2,12,1,12,1C12,0.45,12.45,0,13,0C13.55,0,14,0.45,14,1C14,1,14,2,14,2C14,2,15,2,15,2C15.55,2,16,2.45,16,3C16,3.55,15.55,4,15,4C15,4,14,4,14,4C14,4,14,5.00484,14,5.00484C14,5.55484,13.55,6.00484,13,6.00484C12.45,6.00484,12,5.55484,12,5.00484C12,5.00484,12,4,12,4C12,4,11,4,11,4C10.45,4,10,3.55,10,3C10,3,10,3,10,3Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'IssueNew',
} as DefineComponent
</script>
